import * as React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import {openTermsAndConditions, setSelectedTCPromoId} from "../../../actions/promoBetActions";
import {getPromoBannerArray} from "../helpers/promoToolHelper";
import style from '../css/promoCarousel.css';
import {openCloseAccumulatorBoost} from "../../../actions/accumulatorBoostAction";
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);


function SwipeablePromoMobileBanner({store}) {
    let screenSize = 'mobile';
    let storeData = store.getState();
    const [activeStep, setActiveStep] = React.useState(0);
    let bannerArray = getPromoBannerArray(storeData.vpp.promoBalances,screenSize,storeData.vpp.systemLanguage);

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    const handleClick = (id)=> {
        if(id === 'Accaboost')
            store.dispatch(openCloseAccumulatorBoost())
        else {
            store.dispatch(setSelectedTCPromoId(id));
            store.dispatch(openTermsAndConditions());
        }
    }
    //return empty if nothing to show
    if((bannerArray.length === 0)){
        return ''
    }
    return (
        <div className={style.container}>
            <AutoPlaySwipeableViews
                index={activeStep}
                onChangeIndex={handleStepChange}
                interval={5000}
                resistance={true}
                enableMouseEvents >
                {bannerArray.map((step, index) => (
                    <div key={step.id} onClick={() => {
                        handleClick(step.id)
                    }}>
                        {
                            <div className={style.imageBannerContainer}>
                                <img className={style.imageBanner} src={step.img}/>
                            </div>
                        }
                    </div>
                ))}
            </AutoPlaySwipeableViews>
        </div>
    );
}

export default  (SwipeablePromoMobileBanner);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/promoCarousel.js